import RichText from '@eneco/components/RichText/RichText';
import { IntermediateSettlementBillInclReasonCardResponse } from '@eneco/dc-be/client';
import { Stack } from '@eneco/sparky';
import { EnergyBill } from '@eneco/sparky/illustrations';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';
import { billInsertNotificationMap } from '../../../../utils/billInsertNotificationMap';

export const IntermediateSettlementBillInclReasonCard = ({
  card,
}: {
  card: IntermediateSettlementBillInclReasonCardResponse;
}) => {
  const { fields } = useContent<DashboardOverviewRendering>();

  const {
    details: {
      billInsertReason,
      summary: { records },
    },
  } = card;

  const amountOfBillingAccounts = records.length;
  const [_, content] = billInsertNotificationMap(billInsertReason, fields.billInsertsNotifications);

  return (
    <StyledDashboardBlock>
      <Stack gap="4" direction="row" alignY="center">
        <Stack.Item shrink={false}>
          <EnergyBill />
        </Stack.Item>
        <Stack gap="2">
          <RichText html={fields.intermediateSettlementBillInclReasonCard?.description.value} />
          <RichText html={content} />
        </Stack>
      </Stack>
      {amountOfBillingAccounts > 1 ? (
        <DashboardLink
          href={fields.intermediateSettlementBillInclReasonCard?.invoicesLink.value.href}
          emphasis="high"
          trackingComponentName="intermediate_settlement_bill_invoices_link"
          trackingComponentType="dashboard_link">
          {fields.intermediateSettlementBillInclReasonCard?.invoicesLink.value.text}
        </DashboardLink>
      ) : (
        <DashboardLink
          href={fields.intermediateSettlementBillInclReasonCard?.payLink.value.href}
          emphasis="high"
          trackingComponentName="intermediate_settlement_bill_pay_link"
          trackingComponentType="dashboard_link">
          {fields.intermediateSettlementBillInclReasonCard?.payLink.value.text}
        </DashboardLink>
      )}
    </StyledDashboardBlock>
  );
};
